import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SearchIconButtonWrapper = styled.div`
  flex-shrink: 0;
  margin-left: ${Spacing.S8};
`
